/**
 * Meal courses — the `meal_course` taxonomy in the WordPress original.
 *
 * `rank` is the global course order (superset = Carte order) used to sort
 * dishes within a day regardless of menu type. Ported from
 * HOTEL_MENU_EDIT_COURSE_RANK in child-theme/inc/menu-editor.php.
 *
 * glace / boisson / vin were dropped 2026-06-05 — managed in Lightspeed,
 * never shown online; their terms were deleted.
 */
export const COURSES = [
  { slug: 'entree', label: 'Entrée', rank: 1 },
  { slug: 'plat-principal', label: 'Plat principal', rank: 2 },
  { slug: 'tartiflette', label: 'Tartiflette', rank: 3 },
  { slug: 'pates', label: 'Pâtes', rank: 4 },
  { slug: 'fromages', label: 'Fromages', rank: 5 },
  { slug: 'dessert', label: 'Dessert', rank: 6 },
] as const;

export type CourseSlug = (typeof COURSES)[number]['slug'];

/** Global course-slug → rank map (lower prints first). */
export const COURSE_RANK: Record<CourseSlug, number> = Object.fromEntries(
  COURSES.map((c) => [c.slug, c.rank]),
) as Record<CourseSlug, number>;

export const COURSE_SLUGS: readonly CourseSlug[] = COURSES.map((c) => c.slug);
